import AuthSlider from './AuthSlider';

export default AuthSlider;
